export default {
	colors: {
		primary: {
			100: '#CEE6F5',
			200: '#9FD1ED',
			300: '#7FBCDF',
			400: '#4DA8DB',
			500: '#2A90CB', // background 
			600: '#1579B0',
			700: '#0D6CA6',
			800: '#005487', // default for buttons
			900: '#273A5E',
		},
		secondary: {
			500: '#D10031',
		},
		disabled: '#ccc',
		purple: '#273A5E',
	},
	// config: {
	// 	initialColorMode: 'dark',
	// },
	components: {
		Text: {
			defaultProps: {
				fontFamily: 'Roboto_400Regular',
			},
		},
		Select: {
			defaultProps: {
				h: 50,
				flex: 1,
				bg: '#fff',
				borderWidth: 1,
				borderColor: '#000',
				isDisabled: false,
			},
		},
		Icon: {
			defaultProps: {
				size: 'sm',
			},
		},
		Input: {
			variants: {
				form: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					return {
						autoCapitalize: 'none',
						mb: 4,
						w: '100%',
						h: '50px',

						// BEGIN Taken from variant 'filled'
						bg: props.bg || (isLightMode ? 'muted.200' : 'muted.600'),
						borderWidth: '1',
						borderColor: 'transparent',
						_hover: {
							bg: isLightMode ? 'muted.200' : 'muted.700',
						},
						// END
					};
				},
			},
			defaultProps: {
				size: 'xl',
			},
		},
		Button: {
			variants: {
				footer: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						flex: 1,
						alignSelf: 'center',
						alignItems: 'center',
						justifyContent: 'center',

						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: c + '.800',
						_hover: {
							bg: c + '.600'
						},
						_pressed: {
							bg: c + '.700'
						},
						_focus: {
							bg: c + '.600'
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
			},
			defaultProps: {
				size: 'lg',
			},
		},
		IconButton: {
			variants: {
				footer: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						flex: 1,
						alignSelf: 'center',
						alignItems: 'center',
						justifyContent: 'center',

						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: c + '.800',
						_hover: {
							bg: c + '.600'
						},
						_pressed: {
							bg: c + '.700'
						},
						_focus: {
							bg: c + '.600'
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
			},
			defaultProps: {
				size: 'lg',
			},
		},
	},
};

